interface CheckAndPrintProps {
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    data: any
    className?: string
    feilmelding?: string
}

const CheckAndPrint = (props: CheckAndPrintProps) => {
    const { data, feilmelding = '' } = props

    return props.data != null ? data : feilmelding
}

export default CheckAndPrint
